// @mui icons
import Icon from "@mui/material/Icon";

// This route configuration is specifically for CUSTOMER_EMPLOYEE users
// They can only see their own tickets and are restricted from accessing other features
const customerEmployeeRoute = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: "Dashboard",
  },
  {
    type: "collapse",
    name: "My Tickets",
    key: "my-tickets",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/my-tickets",
    component: "MyTickets",
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: "Profile",
  },
];

export default customerEmployeeRoute;
